/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StatusItem
 */
export interface StatusItem {
    /**
     *
     * @type {number}
     * @memberof StatusItem
     */
    statusItemId?: number;
    /**
     *
     * @type {string}
     * @memberof StatusItem
     */
    deviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof StatusItem
     */
    connectorIndex?: number;
    /**
     *
     * @type {Date}
     * @memberof StatusItem
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof StatusItem
     */
    updatedAt?: Date;
    /**
     *
     * @type {string}
     * @memberof StatusItem
     */
    status?: string;
    /**
     *
     * @type {string}
     * @memberof StatusItem
     */
    reason?: string;
}

/**
 * Check if a given object implements the StatusItem interface.
 */
export function instanceOfStatusItem(value: object): value is StatusItem {
    return true;
}

export function StatusItemFromJSON(json: any): StatusItem {
    return StatusItemFromJSONTyped(json, false);
}

export function StatusItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): StatusItem {
    if (json == null) {
        return json;
    }
    return {
        statusItemId:
            json["statusItemId"] == null ? undefined : json["statusItemId"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        status: json["status"] == null ? undefined : json["status"],
        reason: json["reason"] == null ? undefined : json["reason"],
    };
}

export function StatusItemToJSON(value?: StatusItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        statusItemId: value["statusItemId"],
        deviceIdentity: value["deviceIdentity"],
        connectorIndex: value["connectorIndex"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        status: value["status"],
        reason: value["reason"],
    };
}
